import { useEffect, useRef, useState } from 'react';

const useMinimumLoadingVisibility = (loading, minVisibleMs = 1200) => {
  const [visible, setVisible] = useState(Boolean(loading));
  const startedAtRef = useRef(0);
  const hideTimerRef = useRef(null);

  useEffect(() => {
    if (loading) {
      if (hideTimerRef.current) {
        window.clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
      if (!visible) {
        startedAtRef.current = Date.now();
        setVisible(true);
      } else if (!startedAtRef.current) {
        startedAtRef.current = Date.now();
      }
      return undefined;
    }

    if (!visible) return undefined;

    const elapsed = Date.now() - (startedAtRef.current || Date.now());
    const remain = Math.max(0, Number(minVisibleMs || 0) - elapsed);
    hideTimerRef.current = window.setTimeout(() => {
      hideTimerRef.current = null;
      startedAtRef.current = 0;
      setVisible(false);
    }, remain);

    return () => {
      if (hideTimerRef.current) {
        window.clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
    };
  }, [loading, minVisibleMs, visible]);

  useEffect(
    () => () => {
      if (hideTimerRef.current) {
        window.clearTimeout(hideTimerRef.current);
        hideTimerRef.current = null;
      }
    },
    []
  );

  return visible;
};

export default useMinimumLoadingVisibility;
